export default "__VITE_ASSET__ByFgg$3I__"